import React from 'react'

import statsIcon from '../assets/img/icons/calculator.svg'
import teamIcon from '../assets/img/icons/contacts.svg'
import referralsIcon from '../assets/img/icons/referrals.svg'
import revenueIcon from '../assets/img/icons/savings.svg'
import { SidebarPage } from '../components/layouts/DashboardLayout/components/sidebar/Sidebar'
import SvgImage from '../components/misc/SvgImage'
import { GROUP_DASHBOARD_SIDEBAR_LINKS } from '../lib/constants'
import { ROUTES } from '../lib/routes'
import { useNotificationsCount } from './useNotificationsCount'

export function useGroupDashboardSidebarLinks() {
  const notificationsCount = useNotificationsCount()

  const links: SidebarPage[] = []

  const referralsLink: SidebarPage = {
    title: GROUP_DASHBOARD_SIDEBAR_LINKS.referrals,
    href: ROUTES.referrals,
    icon: <SvgImage src={referralsIcon} alt="Referrals" />,
    badge:
      notificationsCount.referrals > 0
        ? `${notificationsCount.referrals}`
        : undefined,
  }

  const revenueLink: SidebarPage = {
    title: GROUP_DASHBOARD_SIDEBAR_LINKS.revenue,
    href: ROUTES.revenue,
    icon: <SvgImage src={revenueIcon} alt="Revenue" />,
  }

  const statsLink: SidebarPage = {
    title: GROUP_DASHBOARD_SIDEBAR_LINKS.stats + ' (Soon)',
    href: '#',
    icon: <SvgImage src={statsIcon} alt="Stats" />,
    style: { opacity: 0.25 },
  }

  const teamManagementLink: SidebarPage = {
    title: GROUP_DASHBOARD_SIDEBAR_LINKS.teamManagement + ' (Soon)',
    href: '#',
    icon: <SvgImage src={teamIcon} alt="Team Management" />,
    style: { opacity: 0.25 },
  }

  links.push(referralsLink)
  links.push(revenueLink)
  links.push(statsLink)
  links.push(teamManagementLink)

  return links
}
